import { useEffect } from 'react';
import { updateAppBar, IAppBarConfig, IAppMenuBarConfig, IAppBarMenuConfig } from './useWebviewCallback';
import Cookies from 'js-cookie';
import { inApp } from '@utils/platformDetection.client';

export const useAppBarUpdate = (config: IAppBarConfig | IAppMenuBarConfig | IAppBarMenuConfig, enabled: boolean = true) => {
  useEffect(() => {
    if (!enabled) return;
    
    const isWebView = Boolean(Cookies.get('webview'));
    
    if (isWebView) {
      updateAppBar(config);

      if ('is_appbar_transparent' in config && config.is_appbar_transparent) {
        const nativeHeaderHeight = Cookies.get('native_header_height');
        if (nativeHeaderHeight && typeof document !== 'undefined') {
          const headerElement = document.querySelector('header');
          if (headerElement) {
            headerElement.style.paddingTop = `${nativeHeaderHeight}px`;
          } else {
            const mainElement = document.querySelector('main');
            if (mainElement) {
              mainElement.style.paddingTop = `${nativeHeaderHeight}px`;
            }
          }
        }
      }
    }
  }, [config, enabled]);
};

export const getNativeHeaderHeight = (): number => {
  if (typeof window === 'undefined') return 0;
  
  const isWebView = inApp();
  if (!isWebView) return 0;
  
  const height = Cookies.get('native_header_height');
  return height ? parseInt(height, 10) : 0;
};

export const isInWebView = (): boolean => {
  if (typeof window === 'undefined') return false;
  return Boolean(Cookies.get('webview'));
};

